import React, { Component } from "react";
import PropTypes from "prop-types";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Collapse from "@material-ui/core/Collapse";
import ListHeader from "../components/ListHeader";
import PortletAttachments from "../components/attachment/CorePortletAttachments";
import { withStyles } from "@material-ui/core/styles";
import axios from "../AxiosClient";
import PubSub from "pubsub-js";
import { PORTLET_LAYOUT_UPDATE } from "../utils/Topics";
import TaxonomyTree from "../components/taxonomy/TaxonomyTree";
import Divider from "@material-ui/core/Divider";
import PropertyNames from "../PropertyNames";
import { AutoSizer } from "react-virtualized";
import TaxonomySelector from "../components/taxonomy/TaxonomySelector";
import { EqualizerSharp } from "@material-ui/icons";
import { areEqual } from "react-window";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Role, currentUserHasRole } from "../utils/RoleUtils";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";

const styles = (theme) => ({
  // card: {
  //   height: "100%",
  // },
  // list: {
  //   height: "100% !important",
  //   display: "flex",
  //   flexDirection: "column",
  //   flex: 1,
  // },
  // container: {
  //   minHeight: "100% !important",
  //   display: "flex",
  //   flexDirection: "column",
  //   flex: 1,
  // },
  card: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  list: {
    height: "100% ",
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  container: {
    minHeight: "100% ",
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
});
const equal = require("deep-equal");
const areObjectsEqual = (obj1, obj2) => {
  return equal(obj1, obj2) ? true : false;
};

const portletsNotAvailableToMobile = [
  "com.kpsol.api.apicommon.stats.MyStatsInterface",
  "com.kpsol.api.apicommon.document.TaxonomyDocumentInterface",
];
export default function CoreCard(WrappedElement) {
  const mapStateToProps = (state) => ({
    currentLayout: state.layout.currentLayout,
    currentUser: state.user.currentUser,
    teamLayoutEditMode: state.layout.teamLayoutEditMode,
  });
  const mapDispatchToProps = {
  };
  return connect(
      mapStateToProps,
      mapDispatchToProps
    )(withStyles(styles)(
    class extends Component {
      static propTypes = {
        fullscreen: PropTypes.bool,
      };
      constructor(props) {
        super(props);
        this.state = {
          //    fullscreen: this.props.portlet.fullscreen,
          expanded: true,
          portlet: null,
          bottomScrolled: true,
          fullscreenPagination: {pageSize:20, page: 0},
          isExternalDocument: false,
          taxonomySelection: [],
          taxonomyControl: null,
        };
      }

      componentDidMount() {
        const portlet = Object.assign({}, this.props.portlet);
        // if (!this.props.portlet.instance) {
        //   portlet.instance = new Date().getTime().toString();
        // }
        const taxFilters =
          this.props.parameters && this.props.parameters.taxonomy
            ? this.props.parameters.taxonomy
            : this.props.portlet.parameters &&
              this.props.portlet.parameters != "null" &&
              (this.props.portlet.parameters instanceof String ||
                typeof this.props.portlet.parameters === "string")
              ? JSON.parse(this.props.portlet.parameters).hasOwnProperty(
                  "taxonomy"
                )
              : this.props.portlet.parameters.hasOwnProperty("taxonomy")
                ? JSON.parse(this.props.portlet.parameters).taxonomy
                : this.props.taxonomyNodeLookup;
        this.setState({
          portlet: portlet,
          isExternalDocument: this.props.portlet.elementType === "CardDocument",
          taxonomySelection: taxFilters,
        });
        this.props.portlet.fullscreen &&
          this.props.setFullscreen &&
          this.props.setFullscreen(
            this.props.portlet.fullscreen,
            this.props.portlet
          );

        // if (
        //   this.props.portlet.fullscreen &&
        //   this.props.portlet.fullscreenPagination
        // ) {
        //   let fullscreenPagination = JSON.parse(
        //     this.props.portlet.fullscreenPagination
        //   );
        // }
      }

      componentDidUpdate(prevProps, prevState) {
        if (prevProps.fullscreen !== this.props.fullscreen) {
          // toggle
        }
        if (this.props.filters !== prevProps.filters) {
          this.setState({ filters: this.props.filters });
        } else if (
          this.props.menuDialog === true &&
          !areObjectsEqual(this.props.parameters, this.state.filters)
        ) {
          this.setState({ filters: { ...this.props.parameters } });
        }

        if (this.props.portlet !== prevProps.portlet) {
          this.setState({ portlet: this.props.portlet });
        }
      }
      toggleFullscreen = () => {
        this.props.setFullscreen(!this.props.fullscreen, this.props.portlet);
        // this.setState({ fullscreen: !this.state.fullscreen }, () => {
        this.updatePortletFullscreen(!this.props.fullscreen);
        // });
      };

      toggleExpand = () => {
        this.setState((prev) => {
          return { expanded: !prev.expanded };
        });
      };

      onScroll = (e) => {
        const bottom =
          e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        if (bottom) {
          this.setState({ bottomScrolled: true });
        } else {
          this.setState({ bottomScrolled: false });
        }
      };

      updatePortletFullscreen = (fullscreen) => {
        let portlet = this.props.portlet;
        portlet.fullscreen = fullscreen;
        let fullscreenPagination = 
          this.state.fullscreenPagination && 
          this.state.fullscreenPagination != null && 
          this.state.fullscreenPagination !== "null"
            ? this.state.fullscreenPagination
            :
              {
                pageSize: this.state.fullscreenPageSize,
                page: 0,
              }
        portlet.fullscreenPagination = JSON.stringify(this.state.fullscreenPagination)

        if (portlet.portalLayoutID &&
          (this.props.currentLayout.layoutType === "user" ||
            (this.props.currentLayout.layoutType === "team" &&
              this.props.teamLayoutEditMode === true &&
              currentUserHasRole(Role.TEAM_LEADER))))
          {
          axios
            .patch(
              `/portalLayout/${this.props.portlet.portalLayoutID}/portlet/${
                this.props.portlet.id
              }`,
              {
                ...portlet,
              }
            )
            .then((res) => {
              this.setState({ filters: res.data.parameters });
              PubSub.publish(PORTLET_LAYOUT_UPDATE, {
                portlet: res.data,
              });
            });
        }
      };

      updatePortlet = (params) => {
        let portlet = JSON.parse(JSON.stringify(this.props.portlet));
        portlet.parameters = JSON.stringify(params);
        portlet.parametersString = JSON.stringify(params);
        portlet.fullscreen = this.props.fullscreen;
        // this.state.filters !== null &&
        // this.props.updateFilters(params, true, this.props.portlet.instance);
        this.props.updateFilters &&
          this.props.updateFilters(params, true, this.props.portlet.instance);
        if (
          portlet.portalLayoutID &&
          this.props.currentLayout.layoutType !== "team"
        ) {
          axios
            .patch(
              `/portalLayout/${this.props.portlet.portalLayoutID}/portlet/${
                this.props.portlet.id
              }`,
              {
                ...portlet,
              }
            )
            .then((res) => {
              this.setState({ filters: res.data.parameters });
              PubSub.publish(PORTLET_LAYOUT_UPDATE, { portlet: res.data });
            });
        } else if (this.props.currentLayout.layoutType === "team") {
          //so if we have a team layout and the owner changes the filters we want to
          //make the change WITHOUT saving the changes back to the portlet as they have
          //to conciously do that with the use of the save button
          this.setState({ filters: params });
          PubSub.publish(PORTLET_LAYOUT_UPDATE, { portlet: portlet });
        }
      };

      isPageZero = (fullscreenPageSize) => {
        let isPageZero = false;
        if (this.state.pageSize && this.state.pageSize != fullscreenPageSize) {
          isPageZero = true;
        } else if (
          this.props.portlet.fullscreenPagination && 
          this.props.portlet.fullscreenPagination != "null" &&
          JSON.parse(this.props.portlet.fullscreenPagination).pageSize !=
            fullscreenPageSize
        ) {
          isPageZero = true;
        }
        return isPageZero;
      };

      updateData = (data) => {
        this.setState({ data });
      };
      isExternalDocument = () => {
        this.setState({ isExternalDocument: true });
      };

      reHydrateTaxonomy = (filter) => {
        // taxonomy selections saved for portlets do not contain all taxonomy nodes,
        // only those highest up in the tree that are selected add back the children
        let hydrated = [];
        !areObjectsEqual(filter, this.props.taxonomyNodeLookup) &&
          filter.filter((f) => f.type === "taxonomy").forEach((t) => {
            hydrated = hydrated.concat(
              this.getChildren(
                this.props.taxonomyNodeLookup.filter(
                  (l) => l.id === t.id && l.type === "taxonomy"
                )[0]
              )
            );
          });
        let newFilter = filter.concat(hydrated);
        return newFilter;
      };
      getChildren = (node) => {
        let childNodes = node && node.children ? [...node.children] : [];
        if (node) {
          node.children.forEach(
            (c) => c.children && childNodes.push(...this.getChildren(c))
          );
        }
        return childNodes;
      };
      prepareTaxonomyNodes = (taxonomyFilter) => {
        //Create a list of TaxonomySelections (taxonomies or communities)

        //filter taxonomies to only include those whose parent is not present (otherwise they are included implicitly)
        let taxonomies = taxonomyFilter.filter(
          (ele) => ele.type === "taxonomy" && ele.children.length > 0
        );

        //get all the topic nodes and filter any whose parents are in the list of taxonomies and filter out any duplicates
        let topics = taxonomyFilter
          .filter((ele) => ele.type === "topic")
          .filter((ele) => {
            return (
              ele.type === "topic" &&
              ele.parentList &&
              ele.parentList.length > 0 &&
              taxonomies
                .map((t) => t.id)
                .indexOf(ele.parentList[ele.parentList.length - 1]) === -1
            );
          })
          .filter((topic, index, topicArray) => {
            const _topic = JSON.stringify(topic);
            return (
              index ===
              topicArray.findIndex((obj) => {
                return JSON.stringify(obj) === _topic;
              })
            );
          });

        if (topics.length > 0) {
          topics = topics
            .filter(
              (topic) =>
                taxonomies.map((ele) => ele.id).indexOf(topic.id) === -1
            )
            .map((ele) => {
              return {
                id: ele.object ? ele.object[ele.type + "Id"] : ele.id,
                type: ele.type,
                parentList: ele.parentList,
              };
            });
        }
        //now process the taxonomies and put the nodes highest up the list into a filtered list
        let filteredTaxonomies = [];
        let sorted = taxonomies.sort((a, b) => {
          return a.parentList.length > b.parentList.length
            ? 1
            : a.parentList.length < b.parentList.length
              ? -1
              : 0;
        });
        sorted = [...new Set(sorted)];
        sorted.forEach(
          (tax) =>
            taxonomies
              .map((ele) => ele.id)
              .indexOf(tax.parentList[tax.parentList.length - 1]) === -1 &&
            filteredTaxonomies.push(tax)
        );
        let filtered =
          topics &&
          topics.concat(
            filteredTaxonomies.map((ele) => {
              return { id: ele.id, type: ele.type };
            })
          );
        return filtered;
      };

      getTaxonomy = (filter) => {
        let filters = filter
          ? filter.length > 0 &&
            !areObjectsEqual(filter, this.props.taxonomyNodeLookup)
            ? this.reHydrateTaxonomy(filter)
            : this.props.taxonomyNodeLookup
          : this.props.taxonomyNodeLookup;
        return filters;
      };

      setTaxonomy = (e) => {
        // let filters = JSON.parse(portlet.parameters);
        let filters = this.getFiltersToUse();
        if (
          e.filter(
            (ele) => ele.type === "taxonomy" && ele.parentList.length === 0
          ).length === 0
        ) {
          // the root node is not present so a filter is set...
          filters.taxonomy = this.prepareTaxonomyNodes(e);
          this.setState({ taxonomySelection: filters.taxonomy });
        } else {
          // the root node is present so remove any filter as this is treated as all knowledge selected
          delete filters.taxonomy;
          this.setState({ taxonomySelection: this.props.taxonomyNodeLookup });
        }
        this.updatePortlet(filters);
      };

      getFiltersToUse = () => {
        let filters = {};

        if (this.props.menuDialog === true) {
          //we are not a portlet but a direct menu call
          //state for the taxonomy selector is local
          //so use that
          filters =
            this.props.parameters && this.props.portlet.parameters !== "null"
              ? { ...this.props.parameters }
              : {};
          filters.taxonomy = this.state.taxonomySelection;
        } else {
          filters =
            this.state.portlet &&
            this.state.portlet.objectClass &&
            !!this.props.portlet.parameters &&
            this.props.portlet.parameters !== "null"
              ? JSON.parse(this.props.portlet.parameters)
              : {};
        }
        return filters;
      };

      getList = () => {
        const { classes, ...withoutClasses } = this.props;
        const filters2Use = this.getFiltersToUse();
        return (
          <CardContent
            classes={{ root: classes.cardContentRoot }}
            className={classes.list}
            style={
              // this.props.fullscreen && this.state.isExternalDocument
              // ?
              {
                padding: 0,
                flex: 1,
                // height:
                //   this.props.isMobile &&
                //   this.props.menuDialog &&
                //   "calc(100% - 160px)",
                overflow:
                  this.props.isMobile && this.props.menuDialog && "auto",
              }
              //  : { padding: 0, flex: 1 }
            }
          >
            <PortletAttachments
              isportlet={this.props.isPortlet}
              top
              portlet={this.props.portlet}
            />
            <>
              {this.props.sidebarTaxonomyFilter == true ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    height: "100%",
                  }}
                >
                  <div
                    id="taxonomy"
                    style={{
                      width: "30%",
                      height: "100%",
                      minWidth: "100",
                      // overflowY: "auto",
                      // overflowX: "hidden",
                    }}
                  >
                    <AutoSizer>
                      {({ height, width }) => (
                        <div
                          style={{
                            height: height,
                            width: width,
                            overflow: "auto",
                          }}
                        >
                          <TaxonomyTree
                            fullWidth
                            allowedSelections={["taxonomy", "topic"]}
                            hideTopics={
                              this.props.properties[
                                PropertyNames.DISPLAY_TOPICS_IN_DOC_TAX_PORTLET
                              ] != "true"
                            }
                            multiSelect
                            onNodeSelected={this.setTaxonomy}
                            noElevate
                            // treeType="searchTree"
                            expanded
                            fullscreen
                            filter={this.getTaxonomy(filters2Use.taxonomy)}
                          />

                          {/* <>{this.state.taxonomyControl !== null && this.state.taxonomyControl}</> */}
                        </div>
                      )}
                    </AutoSizer>
                  </div>
                  <Divider orientation="vertical" />
                  <div
                    id="list"
                    style={{
                      width: "100%",
                      // height: "calc(100% - 8px)",
                      // overflow: "auto",
                      paddingLeft: 12,
                      paddingTop: 8,
                    }}
                  >
                    {this.getWrappedElement(filters2Use)}
                  </div>
                </div>
              ) : (
                this.getWrappedElement(filters2Use)
              )}
            </>
            <PortletAttachments
              isportlet={this.props.isPortlet}
              top={false}
              portlet={this.props.portlet}
            />
          </CardContent>
        );
      };

      getWrappedElement = (filters2Use) => {
        const { classes, ...withoutClasses } = this.props;
        return (
          <WrappedElement
            updateData={this.updateData}
            updateFullscreenPagination={(fullscreenPageSize, page) => {
              let isPageZero = this.isPageZero(fullscreenPageSize);
              this.setState({
                fullscreenPagination: {
                  pageSize: fullscreenPageSize,
                  page: isPageZero ? 0 : page ? page : 0,
                },
              },() => {this.updatePortletFullscreen(this.props.fullscreen)});
            }}
            expanded={this.state.expanded}
            isPortlet={this.props.isPortlet}
            messageType={
              this.state.portlet.elementType !== "CardDocument"
                ? this.state.portlet.objectClass
                : ""
            }
            toggleFullscreen={this.toggleFullscreen}
            {...withoutClasses}
            portlet={this.props.portlet}
            updatePortlet={this.updatePortlet}
            updateMenuPortlet={this.props.updatePortlet}
            filters={filters2Use}
          />
        );
      };
      returnTaxonomyControl = (taxonomyControl) => {
        this.state.taxonomyControl === null &&
          this.setState({ taxonomyControl: taxonomyControl });
      };

      portletUnavailable = () => {
        return (
          <Alert
            style={{
              height: "calc(100% - 130px)",
              backgroundColor: "white",
            }}
            severity="info"
          >
            <AlertTitle>Info</AlertTitle>
            <Trans i18nKey="portlet_not_available_mobile" />
          </Alert>
        );
      };

      render() {
        const { classes, ...withoutClasses } = this.props;
        let filters2Use = this.getFiltersToUse();
        return (
          this.state.portlet && (
            <>
              {this.props.listOnly ? (
                this.getList()
              ) : (
                <Card
                  className={classes.card}
                  style={{
                    boxShadow: !this.props.isPortlet ? "none" : null,
                    overflowY: this.state.portlet && (this.state.portlet.fullscreen === true || this.props.width > 2) ? "auto" : null,
                  }}
                >
                  <ListHeader
                    data={this.state.data}
                    fullscreenPagination={this.state.fullscreenPagination}
                    menuDialog={this.props.menuDialog}
                    onAddNewList={this.addListToLayout}
                    toggleExpand={this.toggleExpand}
                    toggleFilters={this.props.toggleFilters}
                    updateFilters={this.props.updateFilters}
                    resetToDefaultFilters={this.props.resetToDefaultFilters}
                    settingsElement={this.props.settingType}
                    setTaxonomy={this.setTaxonomy}
                    isportlet={this.props.isPortlet}
                    toggleFullscreen={this.toggleFullscreen}
                    fullscreen={this.props.fullscreen}
                    portlet={this.props.portlet}
                    setFilterInstance={this.props.setFilterInstance}
                    // filters={this.state.filters}
                    filters={filters2Use}
                    width={this.props.width}
                    noTaxonomy={this.props.sidebarTaxonomyFilter === true || this.props.noTaxonomy}
                    returnTaxonomyControl={this.returnTaxonomyControl}
                    resizing={this.props.resizing}
                  />
                  {/* <div
                    onScroll={this.onScroll}
                    style={{
                      // height: "calc(100% - 72px)",
                      height: "100%",
                      overflow: !this.state.isExternalDocument && "auto",
                    }}
                    // style={{ height: "calc(100% - 72px)" }}
                  >
                    <Collapse
                      in={this.state.expanded}
                      timeout="auto"
                      classes={{
                        wrapper: classes.list,
                        wrapperInner: classes.list,
                        container: classes.container,
                      }}
                      unmountOnExit
                    >
                      {this.getList()}
                    </Collapse>
                  </div> */}
                  <div
                    style={
                      this.props.fullscreen && this.state.isExternalDocument
                        ? {
                            overflow: !this.state.isExternalDocument
                              ? "auto"
                              : "none",
                          }
                        : {
                            height: "100%",
                            overflow: this.state.isExternalDocument
                              ? "auto"
                              : "none",
                          }
                    }
                  >
                    <div style={{ height: "100%" }}>
                      {this.props.isMobile &&
                      portletsNotAvailableToMobile.includes(
                        this.props.portlet.objectClass
                      )
                        ? this.portletUnavailable()
                        : this.getList()}
                    </div>
                  </div>
                </Card>
              )}
            </>
          )
        );
      }
    }
  ));
}
